import * as React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { OverlayTrigger, Icon } from "components/common";
import { Table, Button } from "components/bootstrap";
const QueryHelpButton = styled(Button)`
  padding: 6px 8px;
`;
const useTranslatedEntityName = (entityName) => {
  const { t, i18n } = useTranslation("common");
  const key = `entity_types.${entityName.toLowerCase().replace(/\s+/g, "_")}`;
  return i18n.exists(key, { ns: "common" }) ? t(key) : entityName;
};
const row = (field, description) => /* @__PURE__ */ React.createElement("tr", { key: `row-field-${field}` }, /* @__PURE__ */ React.createElement("td", null, field), /* @__PURE__ */ React.createElement("td", null, description));
const DefaultExample = ({ entityName }) => {
  const { t } = useTranslation("common");
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("p", null, t("query_helper.example_description", { entityName }), /* @__PURE__ */ React.createElement("br", null), /* @__PURE__ */ React.createElement("code", null, t("query_helper.example_query_description")), /* @__PURE__ */ React.createElement("br", null)), /* @__PURE__ */ React.createElement("p", null, t("query_helper.example_id", { entityName }), /* @__PURE__ */ React.createElement("br", null), /* @__PURE__ */ React.createElement("code", null, t("query_helper.example_query_id")), /* @__PURE__ */ React.createElement("br", null)));
};
const QueryHelpPopover = ({ commonFields, fieldMap, example, entityName }) => {
  const { t } = useTranslation("common");
  const translatedEntityName = useTranslatedEntityName(entityName);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement("strong", null, t("query_helper.available_fields"))), /* @__PURE__ */ React.createElement(Table, { condensed: true }, /* @__PURE__ */ React.createElement("thead", null, /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("th", null, t("query_helper.field")), /* @__PURE__ */ React.createElement("th", null, t("query_helper.description")))), /* @__PURE__ */ React.createElement("tbody", null, commonFields.map(
    (field) => row(field, t(`query_helper.common_fields.${field}`, { entityName: translatedEntityName }))
  ), Object.keys(fieldMap).map((field) => row(field, fieldMap[field])))), /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement("strong", null, t("query_helper.examples"))), example || /* @__PURE__ */ React.createElement(DefaultExample, { entityName: translatedEntityName }));
};
const QueryHelper = ({
  commonFields = ["id", "title", "description"],
  fieldMap = {},
  example = void 0,
  entityName = "entity"
}) => {
  const { t } = useTranslation("common");
  return /* @__PURE__ */ React.createElement(
    OverlayTrigger,
    {
      trigger: "click",
      rootClose: true,
      placement: "right",
      overlay: /* @__PURE__ */ React.createElement(QueryHelpPopover, { commonFields, fieldMap, example, entityName }),
      title: t("query_helper.title"),
      width: 500
    },
    /* @__PURE__ */ React.createElement(QueryHelpButton, { bsStyle: "link", title: t("query_helper.show_help") }, /* @__PURE__ */ React.createElement(Icon, { name: "help" }))
  );
};
export default QueryHelper;
